import FormattedMessage from 'I18n/components/FormattedMessage';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { Illustration } from 'foundations-components/transitional/components/Illustration';
import { View } from 'foundations-components/transitional/components/View';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { generatePath } from 'react-router-dom';
import SanitizedText from 'sanitize-text/components/SanitizedText';
import RouterButton from 'ui-addon-react-router-dom/RouterButton';
import { Paths } from '../constants/paths';
import { useScrollToTop } from '../hooks/useScrollToTop';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function UmbrellaCollectionCard({
  title,
  description,
  slug,
  onClick
}) {
  const scrollToTop = useScrollToTop();
  const {
    isMobile
  } = useResponsiveProps({
    isMobile: {
      xs: true,
      md: false
    }
  });
  return /*#__PURE__*/_jsx(CardWrapper, {
    margin: "0",
    blockSize: "100%",
    overflow: "hidden",
    children: /*#__PURE__*/_jsx(CardSection, {
      blockSize: "100%",
      padding: "0",
      margin: "0",
      children: /*#__PURE__*/_jsxs(Flex, {
        alignItems: "stretch",
        flexDirection: isMobile ? 'column-reverse' : 'row',
        gap: "0",
        justifyContent: "space-between",
        minBlockSize: "auto",
        blockSize: "100%",
        margin: "0",
        children: [/*#__PURE__*/_jsxs(Flex, {
          alignItems: "start",
          flexDirection: "column",
          flex: isMobile ? '1' : '0 0 50%',
          justifyContent: "center",
          padding: isMobile ? '600' : '1200',
          children: [/*#__PURE__*/_jsx(Text, {
            as: "h5",
            marginBlockEnd: isMobile ? '400' : '800',
            typography: "heading-300",
            children: title
          }), /*#__PURE__*/_jsx(Text, {
            marginBlockEnd: isMobile ? '400' : '800',
            children: /*#__PURE__*/_jsx(SanitizedText, {
              body: description,
              WrapperComponent: "span"
            })
          }), /*#__PURE__*/_jsx(RouterButton, {
            external: false,
            marginBlockStart: "auto",
            onClick: () => {
              onClick === null || onClick === void 0 || onClick();
              scrollToTop();
            },
            to: generatePath(Paths.FEATURED_COLLECTION, {
              collectionSlug: slug
            }),
            use: "tertiary-extra-light",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "marketplaceStorefront.collectionCard.browseNow"
            })
          })]
        }), /*#__PURE__*/_jsx(Flex, {
          alignItems: "center",
          backgroundColor: "fill-accent-orange-subtle-alt",
          flex: isMobile ? '1' : '0 0 50%',
          justifyContent: "center",
          minBlockSize: "auto",
          padding: "600",
          margin: "0",
          children: /*#__PURE__*/_jsx(View, {
            inlineSize: "150px",
            blockSize: "150px",
            children: /*#__PURE__*/_jsx(Illustration, {
              name: "hubspot-ai",
              alt: "hubspot ai illustration"
            })
          })
        })]
      })
    })
  });
}